import { motion } from "motion/react"

const DISPLAY = "'Tilda Sans', sans-serif"

type PageTitleProps = {
    children: React.ReactNode
    titleKey?: string
}

export default function PageTitle({ children, titleKey }: PageTitleProps) {
    return (
        <motion.h1
            key={titleKey}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className="text-white leading-tight"
            style={{
                fontFamily: DISPLAY,
                fontWeight: 800,
                fontSize: "clamp(28px, 7vw, 56px)",
                letterSpacing: "-0.02em",
            }}>
            {children}
        </motion.h1>
    )
}
